/* =====================================================================
   VELURA — lógica de las secciones de la fase 3
   ===================================================================== */
(function () {
  'use strict';
  const V = (window.Velura = window.Velura || {});
  V.modules = V.modules || {};

  /* ---------------- BOLSA vs VELURA: la bolsa se enfría al bajar ---------------- */
  V.modules.comparativa = function (el, { G, ST, anim }) {
    const duelo = el.querySelector('[data-vl-comp-duelo]');
    const frio = el.querySelector('[data-vl-comp-frio]');
    const merc = el.querySelector('[data-vl-comp-mercurio]');
    const despues = el.querySelector('[data-vl-comp-despues]');
    if (!anim || !G || !ST) { if (despues) despues.style.opacity = 1; if (frio) frio.style.opacity = 0.75; return; }
    const tl = G.timeline({ scrollTrigger: { trigger: duelo, start: 'top 75%', end: 'center 35%', scrub: 0.6 } });
    tl.to(frio, { opacity: 0.8, ease: 'none' }, 0)
      .to(merc, { scaleY: 0.18, background: 'linear-gradient(0deg,#7E97AE,#B7C8D6)', ease: 'none' }, 0)
      .to(despues, { opacity: 1, y: 0, ease: 'none', duration: 0.3 }, 0.6);
    G.set(despues, { y: 10 });
  };

  /* ---------------- NADIE TIENE QUE ENTERARSE ---------------- */
  V.modules.discreto = function (el, { anim }) {
    const car = el.querySelector('[data-vl-disc-carrusel]');
    const cards = Array.from(el.querySelectorAll('[data-vl-disc-card]'));
    const barra = el.querySelector('[data-vl-disc-barra]');
    if (car) {
      // profundidad: cada tarjeta se escala/gira según su distancia al centro
      let pend = false;
      const pintar = () => {
        pend = false;
        const cx = car.getBoundingClientRect().left + car.clientWidth / 2;
        cards.forEach((c) => {
          const r = c.getBoundingClientRect();
          const d = Math.max(-1, Math.min(1, (r.left + r.width / 2 - cx) / (car.clientWidth * 0.75)));
          if (anim) c.style.transform = `translateZ(${-Math.abs(d) * 120}px) rotateY(${d * -10}deg) scale(${1 - Math.abs(d) * 0.08})`;
          c.style.opacity = 1 - Math.abs(d) * 0.35;
        });
        const max = car.scrollWidth - car.clientWidth;
        if (barra) barra.style.transform = `scaleX(${Math.max(0.15, max > 0 ? car.scrollLeft / max : 1)})`;
      };
      const pedir = () => { if (!pend) { pend = true; requestAnimationFrame(pintar); } };
      car.addEventListener('scroll', pedir, { passive: true });
      addEventListener('resize', pedir);
      pintar();

      // arrastre con ratón e inercia (en táctil manda el scroll nativo)
      let x0 = 0, s0 = 0, arr = false, vel = 0, ult = 0, lastX = 0;
      car.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        arr = true; x0 = lastX = e.clientX; s0 = car.scrollLeft; vel = 0; ult = performance.now();
        car.classList.add('is-drag'); car.setPointerCapture(e.pointerId);
      });
      car.addEventListener('pointermove', (e) => {
        if (!arr) return;
        const now = performance.now();
        vel = (e.clientX - lastX) / Math.max(1, now - ult); lastX = e.clientX; ult = now;
        car.scrollLeft = s0 - (e.clientX - x0);
      });
      const soltar = () => {
        if (!arr) return; arr = false;
        let v = -vel * 16;
        const inercia = () => { car.scrollLeft += v; v *= 0.93; if (Math.abs(v) > 0.4) requestAnimationFrame(inercia); else car.classList.remove('is-drag'); };
        inercia();
      };
      car.addEventListener('pointerup', soltar); car.addEventListener('pointercancel', soltar);
      const paso = () => (cards[0] ? cards[0].getBoundingClientRect().width + 14 : 300);
      const prev = el.querySelector('[data-vl-disc-prev]'), next = el.querySelector('[data-vl-disc-next]');
      if (prev) prev.addEventListener('click', () => car.scrollBy({ left: -paso(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => car.scrollBy({ left: paso(), behavior: 'smooth' }));
      car.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') car.scrollBy({ left: paso(), behavior: 'smooth' });
        if (e.key === 'ArrowLeft') car.scrollBy({ left: -paso(), behavior: 'smooth' });
      });
    }

    // comparador antes / después
    const comp = el.querySelector('[data-vl-disc-comp]');
    const rango = el.querySelector('[data-vl-disc-rango]');
    if (comp && rango) {
      const set = (v) => comp.style.setProperty('--pos', v + '%');
      rango.addEventListener('input', () => set(rango.value));
      // pequeña demostración al aparecer: el asa se mueve sola una vez
      if (anim && window.gsap && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => {
          if (!en[0].isIntersecting) return; io.disconnect();
          const o = { v: 50 };
          window.gsap.timeline({ delay: 0.9 })
            .to(o, { v: 22, duration: 0.9, ease: 'power2.inOut', onUpdate: () => set(o.v) })
            .to(o, { v: 78, duration: 1.2, ease: 'power2.inOut', onUpdate: () => set(o.v) })
            .to(o, { v: 50, duration: 0.8, ease: 'power2.inOut', onUpdate: () => { set(o.v); rango.value = o.v; } });
        }, { threshold: 0.5 });
        io.observe(comp);
      }
    }
  };

  /* ---------------- SE AJUSTA A TI ---------------- */
  V.modules.ajuste = function (el, { G, ST, anim }) {
    const elas = el.querySelector('[data-vl-aj-elastico]');
    const num = el.querySelector('[data-vl-aj-num]');
    const cuerpos = Array.from(el.querySelectorAll('[data-vl-aj-cuerpo]'));
    const desde = parseFloat(el.dataset.desde) || 60, hasta = parseFloat(el.dataset.hasta) || 120;
    if (!anim || !G || !ST) { if (num) num.textContent = hasta; if (elas) elas.style.transform = 'scaleX(1)'; return; }
    const o = { v: desde };
    const tl = G.timeline({ scrollTrigger: { trigger: el.querySelector('[data-vl-aj-escena]'), start: 'top 80%', end: 'bottom 40%', scrub: 0.6 } });
    tl.fromTo(elas, { scaleX: 0.55 }, { scaleX: 1, ease: 'none', duration: 1 }, 0)
      .to(o, { v: hasta, ease: 'none', duration: 1, onUpdate: () => (num.textContent = Math.round(o.v)) }, 0);
    cuerpos.forEach((c, i) => {
      tl.to(c.querySelectorAll('path'), { strokeDashoffset: 0, ease: 'none', duration: 0.34 }, i * 0.3);
    });
  };

  /* ---------------- NOCHE: el reloj de 90 minutos corre con el scroll ---------------- */
  V.modules.noche = function (el, { G, ST, anim }) {
    const prog = el.querySelector('[data-vl-noche-prog]');
    const txt = el.querySelector('[data-vl-noche-min]');
    const min = parseFloat(el.dataset.minutos) || 90;
    if (!anim || !G || !ST || !prog) return;
    const o = { p: 0 };
    G.to(o, {
      p: 1, ease: 'none',
      scrollTrigger: { trigger: el, start: 'top 70%', end: 'bottom 60%', scrub: 0.8 },
      onUpdate: () => {
        prog.style.strokeDashoffset = (o.p * 100).toFixed(2);
        const rest = Math.max(0, min * (1 - o.p));
        const m = Math.floor(rest), s = Math.floor((rest - m) * 60);
        txt.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      },
    });
  };

  /* ---------------- PARA QUIÉN: inclinación 3D ---------------- */
  V.modules.regalo = function (el, { anim, fino }) {
    if (!anim) return;
    el.querySelectorAll('[data-vl-tilt]').forEach((c) => {
      const mover = (x, y) => {
        const r = c.getBoundingClientRect();
        const px = (x - r.left) / r.width, py = (y - r.top) / r.height;
        c.style.transform = `perspective(900px) rotateY(${(px - 0.5) * 12}deg) rotateX(${(0.5 - py) * 10}deg) translateZ(0)`;
        c.style.setProperty('--mx', px * 100 + '%'); c.style.setProperty('--my', py * 100 + '%');
      };
      if (fino) {
        c.addEventListener('pointermove', (e) => mover(e.clientX, e.clientY));
        c.addEventListener('pointerleave', () => (c.style.transform = ''));
      } else {
        c.addEventListener('touchstart', (e) => { const t = e.touches[0]; mover(t.clientX, t.clientY); }, { passive: true });
        c.addEventListener('touchend', () => (c.style.transform = ''));
      }
    });
  };

  /* ---------------- PREGUNTAS: acordeón suave ---------------- */
  V.modules.faq = function (el) {
    el.querySelectorAll('.vl-faq__item').forEach((d) => {
      if (d.open) d.classList.add('is-open');
      const s = d.querySelector('summary');
      const a = d.querySelector('.vl-faq__a');
      s.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.classList.contains('is-open')) {
          d.classList.remove('is-open');
          const fin = () => { if (!d.classList.contains('is-open')) d.open = false; };
          a.addEventListener('transitionend', fin, { once: true });
          setTimeout(fin, 700);
        } else {
          d.open = true;
          requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
        }
      });
    });
  };
})();
